class DZModelWiki {
    /**
     * 主键
     */
    id = "";

    /**
     * 百科标题
     */
    title = "";

    /**
     * 分类ID
     */
    type = ""

    /**
     * 列表图片ID
     */
    listCoverId = "";

    /**
     * 来源
     */
    source = "";

    /**
     * 阅读量
     */
    readNum = "";

    /**
     * 资讯内容
     */
    content = "";

    /**
     * 创建时间
     */
    createTime = "";

    imageUrl = "";

    image = "";
}
export default DZModelWiki;
